/**
 * Deck Kinds
 * What The Home CEO is, as the deck says it: AI, plus the three kinds of
 * thing every wish adds
 */

import React from 'react';
import type { EngineKey } from '@components/wish-story/engines';
import { colors } from '@config/colors';

/*
 * June, 2026-09-23: "very clear we're AI + Pre-Fetched Data, Domain Expert
 * Models, and Enhanced Assistant Capabilities". The kinds keep the
 * homepage's colours and icons (`ENGINE_KINDS`, `EngineIcon`); the deck
 * names them in its own words — the homepage's third reads "Assistant
 * capabilities".
 */
export const KIND_NAMES: Record<EngineKey, string> = {
  data: 'Pre-Fetched Data',
  expert: 'Domain Expert Models',
  skills: 'Enhanced Assistant Capabilities',
};

/** AI, the term the kinds are added to: a white disc, beside their
 *  coloured ones. */
export const AI_FILL = colors.white;
export const AI_INK = colors.neutral.extraDark;

/** AI's mark, drawn as the kinds' icons are (`EngineIcon`): a sparkle and
 *  a smaller one. */
export const AiIcon: React.FC<{ size?: number; color?: string }> = ({ size = 30, color = AI_INK }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10 4.5 11.6 9.4 16.5 11l-4.9 1.6L10 17.5l-1.6-4.9L3.5 11l4.9-1.6Z" />
    <path d="M18 15.5v5M15.5 18h5" />
  </svg>
);
